export function checkValid(token: string | null) {
  // TODO: validate jwt (including expiration time)
  return token !== null && token.length > 20;
}
